import RecentProducts from 'components/tailgrids-ui/products/recent-products';
import React from 'react';

const RecentProductsTastic = ({ data }) => {
  return <RecentProducts {...data} />;
};

export default RecentProductsTastic;
